import { get, post, put, delete as remove } from 'axios'

const endpoint = '/groups'
const defaultLimit = 15

function transformFilterFields(fields) {
  const assignedFields = Object.assign({ limit: defaultLimit }, fields)

  return Object.keys(assignedFields)
    .filter(key => !!assignedFields[key])
    .map(key => `${key}=${encodeURIComponent(assignedFields[key])}`)
    .join('&')
}

export const save = data => {
  if (data.id !== undefined) {
    return put(`${endpoint}`, data).catch(formatResponseError)
  }

  return post(`${endpoint}`, data).catch(formatResponseError)
}

export const removeGroup = data => {
  return remove(`${endpoint}/${data._id}`)
}

export const usersInactive = data => {
  return put(`${endpoint}/${data._id}/users-inactive`)
}

export const findById = groupId => {
  return get(`${endpoint}/${groupId}`)
}

export const findAll = () => {
  return get(`${endpoint}`)
}

export const searchGroups = data => {
  const url = `${endpoint}/search?${transformFilterFields(data)}`
  return get(url).then(res => res.data)
}

export const validateManagers = group => {
  return post(`${endpoint}/validate/managers`, group).catch(formatResponseError)
}

export const validateMembers = group => {
  return post(`${endpoint}/validate/members`, group).catch(formatResponseError)
}

export const validateChildren = group => {
  return post(`${endpoint}/validate/children`, group).catch(formatResponseError)
}

export const getGroupsAccess = () => get(`groups/search`).then(res => res)

export const getGroupsAccessTickets = () =>
  get(`groups/search?ctx=tickets`).then(res => res)

export const getGroupsTree = () => get(`${endpoint}/tree`).then(res => res)

function formatResponseError(err) {
  Object.keys(err.response.data).forEach(key => {
    if (Array.isArray(err.response.data[key])) {
      err.response.data[key] = err.response.data[key][0]
    }
  })

  throw err
}

export default {
  save,
  findAll,
  findById,
  searchGroups,
  validateManagers,
  validateMembers,
  validateChildren,
  getGroupsAccess,
  getGroupsAccessTickets,
  getGroupsTree,
  usersInactive,
}
